export function PaydataSheetSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/paydata-sheet.svg'"></ng-include>`
    }
}